import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import getGridWidthClass from '../../utils/getGridWidthClass';
import { useDispatch, useSelector } from 'react-redux';
import Icon from '../Icon';
import { useTheme } from '../../contextProviders';
import SendFilesModal from './SendFilesModal';
import { copyIcon } from '../../../assets/svgIcons/icon';
import Tooltip from '../Tooltip';
import getIcon from '../Icon/getIcon';
import AssignRadiologistModal from '@custom/StudyList/components/assignRadiologistModal';
import { SuccessModal, Notification, Button, ConfirmationPopup, Loader } from '@ohif/ui';
import { assignRadiologistApi } from '@custom/rtk-apis/radiologistuser/assignRadiologist';
import { AppDispatch, RootState } from '@custom/store/store';
import radiologistUserApi from '@custom/rtk-apis/radiologistuser/getRadiologistUser';
import { getCurrentReport } from '@custom/Apis/apis';
import { servicesManager } from '../../../../app/src/App';
import { _roleType, _studyReviewStatus } from '@custom/Utils/constants/appConstants';
import { AET, PACS_URL } from '@custom/constant';
import { getCloudPACSToken } from '@custom/Utils/authUtils';
import veriftReport from '@custom/rtk-apis/report/verifyReport';
import { clearVerifyReports } from '@custom/store/slices/report/verifyReportSlice';
import cancel_teleradiologyApi from '@custom/rtk-apis/teleradiologist/cancelStudy';
import changeReviewStatus from '@custom/rtk-apis/teleradiologist/changeReviewStudyStatus';
import checkHospitalCredit from '@custom/rtk-apis/teleradiologist/checkHospitalCredit';
import deleteReviewStatus from '@custom/rtk-apis/teleradiologist/deleteReviewStatus';
import RejectionModal from './RejectionModal';
import { formatName } from './utils';
import { closeModal } from '@custom/store/slices/teleradiologist/checkHospitalCredit';

const StudyListTableRow = props => {
  const dispatch = useDispatch<AppDispatch>();
  const {
    tableData,
    setStudiesToSend,
    studiesToSend, extractedValues,
    clearFilters,
    isCancelled,
    isAccepted,
    reviewstatusFlag,
    cancellationReason,
    acceptedradiologistId,
    rejected_radiologist_ID,
    acceptance_time,
    isAutoRejected,
    assigned_time,
    isReviewPresent,
    assigned_radiologist,
    aiStudyData
  } = props;
  const { row, expandedContent, onClickRow, isExpanded, dataCY, clickableCY, rawStudyDetails } = tableData;
  const { isDarkMode } = useTheme();
  const role = sessionStorage.getItem('role') || localStorage.getItem('role');
  const hospitalName = sessionStorage.getItem('hospitalName') || localStorage.getItem('hospitalName');

  const divRef = useRef(null);

  const [isSuccessModalOpen, setIsSuccessModal] = useState(false);
  const [DoctorAssigned, setDoctorAssigned] = useState(false);
  const [SuccessMessage, setSuccessMessage] = useState("");
  const [isSendModalExpanded, setIsSendModalExpanded] = useState(false);
  const [isModalRadiologist, setIsModalRadiologist] = useState(false);
  const [OpenErrorModal, setOpenErrorModal] = useState(false);
  const [confirmationModal, setConfirmationModal] = useState({
    title: "",
    message: "",
    type: "",
    isOpen: false,
    onConfirm: null,
  });
  const [checkCreditApi,setCheckCreditApi] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [patientName, setPatientName] = useState('');
  const [assignedDoctor, setAssignedDoctor] = useState('');
  const [RadiologistsList, setRadiologistsList] = useState([]);
  const studyInstanceUid = rawStudyDetails?.studyInstanceUid;
  const modality = rawStudyDetails?.modalities;
  const { uiNotificationService } = servicesManager.services
  const hospitalType = sessionStorage.getItem('hospitalType') || localStorage.getItem('hospitalType');
  const hospitalId = sessionStorage.getItem('hospitalId') || localStorage.getItem('hospitalId');
  const verifyReportResponse = useSelector((state: RootState) => state.verifyReportResponse);
  const getCanceledStudiesResponse = useSelector((state: RootState) => state.getCancelledStudiesResponse);
  const checkHospitalCreditResponse = useSelector((state: RootState) => state.checkHospitalCreditResponse);
  const userId = sessionStorage.getItem('userId') || localStorage.getItem('userId')
  const user_code = sessionStorage.getItem('user_code') || localStorage.getItem('user_code')
  const isTeleradiology = sessionStorage.getItem('teleradiology') || localStorage.getItem('teleradiology')
  const [isPending,setIsPending] = useState(false)
  const [isRejected,setIsRejected] = useState(false)
  const [rejectionReasonText,setRejectionReasonText] = useState('')
  const [rejectionPopup,setRejectionPopup] = useState(false)
  const [showMenu, setShowMenu] = useState(false);
  const getBodyPartExamined = () => {
    let matchItem: any = {};
    extractedValues?.forEach(item => {
      if (item["0020000D"]?.Value?.[0] === studyInstanceUid) {
        matchItem = item;
      }
    });
    return matchItem["00180015"]?.Value?.[0] || '';
  };

  const aiStudiesFlat = Array.isArray(aiStudyData)
    ? aiStudyData.flatMap((d: any) => d?.studies || [])
    : [];
  const aiStudyEntry = aiStudiesFlat.find((s: any) => s?.studyInstanceUID === studyInstanceUid);
  const modalityLower = (rawStudyDetails?.modalities || '').toLowerCase();
  const bodyPartLower = ((aiStudyEntry?.studyRegion || getBodyPartExamined() || '') + '').toLowerCase();
  const modalityFromAiOrStudy = (aiStudyEntry?.modality || modalityLower || '').toLowerCase();
  const isCtOrXray = modalityFromAiOrStudy.includes('ct') || modalityFromAiOrStudy.includes('xray');
  const isBoneChestBrain = ['bone', 'chest', 'brain'].includes(bodyPartLower);
  const isAiEligible = isCtOrXray && isBoneChestBrain;
  const aiStatus = (aiStudyEntry?.status || '').toLowerCase();
  const aiIconName = aiStatus === 'pending' ? 'pendingIcon' : aiStatus === 'error' ? 'errorIcon' : (aiStudyEntry ? 'successIcon' : 'pendingIcon');
  const aiTooltip = aiStatus === 'pending' ? 'AI Pending' : aiStatus === 'error' ? 'AI Error' : (aiStudyEntry ? 'AI Completed' : 'AI Pending');
  const isTeleUser =
    (role === _roleType.radiologist || role === _roleType.pathologist || role === _roleType.superAdmin || role === _roleType.radiologistAdmin) &&
      hospitalType === 'teraradiology'
      ? true
      : false;
  useEffect(() => {
    getListOfRadiologists();
  }, [])

  const getListOfRadiologists = () => {
    const payload = { from: "studies", modality: modality }
    dispatch(radiologistUserApi(payload as any))
      .unwrap()
      .then(response => {
        setRadiologistsList(response?.result);
      })
      .catch(err => {
        console.error('API Error:', err);
      });
  }

  useEffect(() => {
    if (rawStudyDetails?.referringPhysician && Array.isArray(RadiologistsList)) {
      let matchItem = {};
      extractedValues.forEach(item => {
        if (item["0020000D"].Value[0] === rawStudyDetails?.studyInstanceUid) {
          matchItem = item;
        }
      });

      let existingValue = matchItem["00080090"]?.Value?.[0]?.Alphabetic || "";
      const assignedDoc = RadiologistsList.find((doc) => {
        return doc?.user_code === existingValue;
      });

      const filteredRadioloistList = RadiologistsList.filter((r)=>{ return r.user_code == existingValue})
      if(filteredRadioloistList && !rejected_radiologist_ID.includes(filteredRadioloistList[0]?._id) && existingValue !=='MASTER_ADMIN' && !acceptedradiologistId){
        setIsPending(true)
      }else{
        setIsPending(false)
      }
      if(filteredRadioloistList && rejected_radiologist_ID.includes(filteredRadioloistList[0]?._id) && user_code == filteredRadioloistList[0]?.user_code){
         setIsRejected(true)
      }
      else if (filteredRadioloistList && rejected_radiologist_ID.includes(filteredRadioloistList[0]?._id) && (role == 'Superadmin' || role == _roleType.radiologistAdmin)) {
         setIsRejected(true)
      }
      else{
        setIsRejected(false)
      }
      if(acceptedradiologistId == assignedDoc?._id){
        setAssignedDoctor(assignedDoc);
      }else if(reviewstatusFlag !== _studyReviewStatus.REJECTED){
        setAssignedDoctor('')
      }else if(existingValue == 'MASTER_ADMIN'){
      setAssignedDoctor('')
    }else{
      setAssignedDoctor('Pending')
    }
  }}, [rawStudyDetails, RadiologistsList, DoctorAssigned,rejected_radiologist_ID]);

  const handleAssignSuccess = () => {
    setIsModalRadiologist(false);
    setIsSuccessModal(true)
    setSuccessMessage('Radiologist assigned successfully.')
    setDoctorAssigned(true)
  };

  const handleUnassignDoctor = async (e) => {
    e.stopPropagation();
    let matchItem = {};
    extractedValues.forEach(item => {
      if (item["0020000D"].Value[0] === studyInstanceUid) {
        matchItem = item;
      }
    });
    const UID = { studyInstanceUID: matchItem["0020000D"].Value[0] }
    const res = await getCurrentReport(UID)
    if (res.result && res.result.length !== 0) {
      setOpenErrorModal(true)
    } else {
      matchItem["00080090"].Value = [{ "Alphabetic": "" }];
      dispatch(assignRadiologistApi({ studyInstanceUID: studyInstanceUid, keyValueData: matchItem }));
      setAssignedDoctor(null);
      setDoctorAssigned(false)
      setIsSuccessModal(true)
      setSuccessMessage('Radiologist unassigned successfully.')
    }
  };

  const getRowData = (data) => {
    let tempArray = [];
    data?.map((t) => {
      if (t?.key !== 'mrn' && t?.key !== 'accession' && t?.key !== 'instances') {
        tempArray.push(t);
      }
    });
    return tempArray;
  };

  const getInitials = (name) => {
    const name1 = name?.props?.children.replace(',', '').trim();
    const parts = name1.split(' ').filter(Boolean);
    if (parts.length === 1) return parts[0][0]?.toUpperCase();
    const firstInitial = parts[0][0]?.toUpperCase();
    const lastInitial = parts[parts.length - 1][0]?.toUpperCase();
    return firstInitial + lastInitial;
  };

  const getClassAccordingToKey = (key) => {
    if (key === 'patientName') {
      return 'theme-font-color';
    } else {
      return '';
    }
  };

  const btnSendClickHandler = (event) => {
    if (!localStorage.getItem('local_pacs_access_token') && !sessionStorage.getItem('local_pacs_access_token')) {
      uiNotificationService.show({
        title: 'Send DICOM',
        position: 'topRight',
        message: 'No PACS is ACTIVE. Please ACTIVATE a PACS and try again.',
        type: 'error',
      });
      return;
    }
    event.stopPropagation();
    setIsSendModalExpanded(true);
  };

  const handleRadiologist = (e, row) => {
    e.stopPropagation();
    setIsModalRadiologist(true);
    setPatientName(row[0]?.content?.props?.children);
  };

  const isStudySelected = () => {
    const studyInstanceUid = tableData?.rawStudyDetails?.studyInstanceUid;
    return studiesToSend.some(
      (study) => study.studyInstanceUid === studyInstanceUid
    );
  };

  const handleStudySelect = (event) => {
    event.stopPropagation();

    const isChecked = event.target.checked;
    const studyInstanceUid = rawStudyDetails?.studyInstanceUid;

    setStudiesToSend((curr) => {
      if (isChecked) {
        if (!curr.some((study) => study.studyInstanceUid === studyInstanceUid)) {
          return [...curr, tableData?.rawStudyDetails];
        }
        return curr;
      } else {
        return curr.filter((study) => study.studyInstanceUid !== studyInstanceUid);
      }
    });
  };

 useEffect(()=>{
  if( checkHospitalCreditResponse.status === 'SUCCESS' && checkCreditApi && (checkHospitalCreditResponse?.result?.action === 'debit' || checkHospitalCreditResponse?.result?.action === 'No_credit_to_debit') ){
     handleAssignTeleRadiologist();
     setIsLoading(false);
     setCheckCreditApi(false);
  }else if(checkHospitalCreditResponse.status === 'ERROR' && checkCreditApi){
    setIsLoading(false);
    uiNotificationService.show({
      title: 'Error',
      position: 'topRight',
      message: checkHospitalCreditResponse.msg || 'Something went wrong!',
      type: 'error',
    });
    setCheckCreditApi(false)
  }
 dispatch(closeModal());

},[checkHospitalCreditResponse])


 const handleCheckHospitalCredit = async () => {
    setConfirmationModal(prev => ({ ...prev, isOpen: false }));
    setIsLoading(true);
      let id = studyInstanceUid;
      let matchItem = extractedValues.find(item => item["0020000D"].Value[0] === id);
      const patientId = matchItem["00080050"]?.Value?.[0]
      const patientModality = matchItem["00080061"]?.Value?.[0] || '';
      setCheckCreditApi(true);
      await dispatch(checkHospitalCredit({patientId, modality : patientModality}));
  };



  const handleAssignTeleRadiologist = async () => {
    setConfirmationModal(prev => ({ ...prev, isOpen: false }));
    setIsLoading(true);
    try {
      let id = studyInstanceUid;
      const isCancelled = (getCanceledStudiesResponse?.result?.canceledStudies || []).some(
        study => study.studyInstanceUID === studyInstanceUid
      );

      let matchItem = extractedValues.find(item => item["0020000D"].Value[0] === id);
      if (!matchItem) {
        throw new Error("Study details not found!");
      }

      // Get the existing Referring Physician Name value
      let existingValues = matchItem["00080090"]?.Value?.map(item => item?.Alphabetic) || [];

      // Add the new value while keeping the previous ones
      let newPhysician = "MASTER_ADMIN"; // New value to be added
      if (!existingValues.includes(newPhysician)) {
        existingValues.unshift(newPhysician); // Add newPhysician at the beginning
      }

      matchItem["00080090"] = { Value: existingValues.map(value => ({ Alphabetic: value })) };

      await dispatch(assignRadiologistApi({ studyInstanceUID: id, keyValueData: matchItem })).unwrap();

      if (isCancelled) {
        const payload = {
          hospitalId: hospitalId,
          studyInstanceUID: studyInstanceUid
        };
        await dispatch(cancel_teleradiologyApi(payload)).unwrap();
      }

      setIsSuccessModal(true);
      setSuccessMessage("Successfully sent the study to teleradiology.");
      setIsLoading(false);
      setTimeout(() => {
        window.location.reload();
      }, 1000);

    } catch (error) {
      setConfirmationModal(prev => ({ ...prev, isOpen: false }));
      setIsLoading(false);
      console.error("Error:", error);
      uiNotificationService.show({
        title: "Error",
        type: "error",
        message: error.message || "Something went wrong!",
      });
    }
  };

  const IsDuplicateStudy = (str) => {
    const flag = str.includes('duplicate')
    return flag;
  };

  const checkAssignedToSuperadmin = (rawStudyDetails) => {
    if (
      rawStudyDetails &&
      rawStudyDetails.qidoStudy &&
      rawStudyDetails.qidoStudy["00080090"] &&
      rawStudyDetails.qidoStudy["00080090"].Value
    ) {
      return rawStudyDetails.qidoStudy["00080090"].Value.some(
        (item) => item?.Alphabetic === "MASTER_ADMIN"
      );
    }
    return false;
  };

  const handleVerifyReport = async () => {
    dispatch(clearVerifyReports());

    const url = `${PACS_URL}/dcm4chee-arc/aets/${AET}/rs/studies/${studyInstanceUid}/series?limit=21&includefield=all&offset=0&orderby=SeriesNumber`;
    const pacs_token = getCloudPACSToken();
    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${pacs_token}`,
        },
      });
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const data = await response.json();
      const institutionName = data.map(item => item['00080080']?.Value?.[0])[0];

      const formData = {
        studyInstanceUID: studyInstanceUid,
        institutionName: institutionName,
      };
      dispatch(veriftReport(formData)).then((res)=>{
        if (res.payload.status === "SUCCESS") {
          setIsSuccessModal(true);
          setSuccessMessage(res.payload.msg);
        } else if (res.payload.status === "ERROR") {
          uiNotificationService.show({
            title: 'Error',
            message: res.payload.msg,
            type: 'error',
          });
        }
      });
      setConfirmationModal(prev => ({ ...prev, isOpen: false }));
    } catch (err) {
      setConfirmationModal(prev => ({ ...prev, isOpen: false }));
      console.error(err);
    }
  }
 useEffect(()=>{
  if( checkHospitalCreditResponse.status === 'SUCCESS' && checkCreditApi && (checkHospitalCreditResponse?.result?.action === 'credit' || checkHospitalCreditResponse?.result?.action === 'No_credit_to_rollback' )){
     handleCancelSent();
     setCheckCreditApi(false);
  }else if(checkHospitalCreditResponse.status === 'ERROR' && checkCreditApi){
    setIsLoading(false);
    uiNotificationService.show({
      title: 'Error',
      position: 'topRight',
      message: checkHospitalCreditResponse.msg || 'Something went wrong!',
      type: 'error',
    });
    setCheckCreditApi(false)
  }
 dispatch(closeModal());

},[checkHospitalCreditResponse])

const handleMoreClick = (e) => {
  e.stopPropagation();
  setShowMenu(!showMenu)
}


const handleCreditAndCancelSentStudy = async (e) =>{
    e.stopPropagation();
    setConfirmationModal(prev => ({ ...prev, isOpen: false }));
    let id = studyInstanceUid;
      let matchItem = extractedValues.find(item => item["0020000D"].Value[0] === id);
      const patientId = matchItem["00080050"]?.Value?.[0]
      const patientModality = matchItem["00080061"]?.Value?.[0] || '';
     setIsLoading(true);
      extractedValues.forEach(item => {
        if (item["0020000D"].Value[0] === studyInstanceUid) {
          matchItem = item;
        }
      });
      const UID = { studyInstanceUID: matchItem["0020000D"].Value[0] }
      const res = await getCurrentReport(UID)
      if (res.result && res.result.length !== 0) {
        setIsLoading(false);
        uiNotificationService.show({
          title: 'Error',
          message: `Cancellation is not allowed as the report has already been created.`,
          type: 'error',
        });
      } else{
         setCheckCreditApi(true);
        await dispatch(checkHospitalCredit({ patientId , modality:patientModality, action:'cancel'}))
      }
  }

  const handleCancelSent = async () => {
    try {

        const payload = {
          hospitalId: hospitalId,
          studyInstanceUID: studyInstanceUid
        }
        await dispatch(cancel_teleradiologyApi(payload)).unwrap().then(() => {

          setAssignedDoctor(null);
          setDoctorAssigned(false);
          setIsLoading(false);
          setIsSuccessModal(true)
          handleDeleteReviewStatus()
        })
        setIsLoading(false);
      }
    catch (err) {
      setConfirmationModal(prev => ({ ...prev, isOpen: false }));
      console.error("Error", err);
      setIsLoading(false);
      uiNotificationService.show({
        title: 'Error',
        message: 'Something went wrong while canceling the radiologist assignment.',
        type: 'error',
      });
    }
  }

  const handleDeleteReviewStatus = () => {
   const payload = {
    UHID: tableData?.rawStudyDetails?.mrn,
    patientId: tableData?.rawStudyDetails?.accession,
   }
    dispatch(deleteReviewStatus(payload)).unwrap().then((res)=>{
      setSuccessMessage('Radiologist unassigned successfully.')
    }).catch((err) => console.log(err)).finally(() => {
      setTimeout(() => {
        window.location.reload()
      }, 1000);
    })
  }

  const handleChangeReviewStatus = (status) => {
    if(rejectionReasonText?.length < 6 && status == _studyReviewStatus.REJECTED){
      return
    }
    setRejectionPopup(false)
    setConfirmationModal((prev) => ({ ...prev, isOpen: false }))
    setIsLoading(true)
    const payload = {
      hospitalId,
      studyInstanceUID:tableData.clickableCY,
      status,
      reason:'',
      radiologistId:userId,
      action : '',
      priority:""
    }
    if(status == _studyReviewStatus.REJECTED){
      payload['reason'] = rejectionReasonText || ''
    }
    dispatch(changeReviewStatus(payload)).unwrap().then((res)=>{
      setTimeout(() => {
        window.location.reload()
      }, 3000);
    })

  }

  const showActionBtn = () => {
    if(rejected_radiologist_ID.includes(userId)){
      return false
    }else if(acceptedradiologistId == userId){
      return false
    }else{ return true}
  }

  const checkAcceptedStudies = () => {
    if(role == 'Radiologist' && hospitalName == 'superadmin-teleradiology' && isAccepted){
     return true
    }else if(role == 'Radiologist' && hospitalName == 'superadmin-teleradiology' && !isAccepted){
      return false
    }else{
      return true
    }
  }


  const checkCancellStudies = () => {
    if (role == _roleType.superAdmin || (role == _roleType.radiologist && hospitalType == "teraradiology") || role == _roleType.radiologistAdmin) {
      return isCancelled;
    }
    else {
      return false;
    }
  }

  useEffect(() => {
    const handleClickOutside = (event) => {
      // Check if the click is outside the div and showMenu is true (i.e., modal is open)
      if (divRef.current && !divRef.current.contains(event.target) && showMenu) {
        setShowMenu(false); // Close the modal when clicking outside
      }
    };

    // Add event listener when the modal is shown
    if (showMenu) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    // Cleanup the event listener when the modal is closed
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showMenu]);

  // Helper components
type MenuItemProps = { text: any; onClick?: any; disabled?: boolean };
const MenuItem: React.FC<MenuItemProps> = ({text, onClick, disabled = false }) => (
  <div
    className={`flex items-center px-4 py-2 text-sm ${disabled ? 'text-gray-400' : 'text-gray-700 hover:bg-gray-100 cursor-pointer'}`}
    onClick={!disabled ? (onClick || (() => {})) : undefined}
  >
    <span>{text}</span>
  </div>
);

const Divider = () => (
  <div className="border-t border-gray-200 my-1"></div>
);

  return (
    <>
      <tr
        className="select-none" data-cy={dataCY}>
        <td
          className={classnames('border-0 p-0', {
            'border-b': isExpanded && !isDarkMode,
          })}
        >
          <div
            className={classnames(
              'w-full transition duration-300',
              {
                'border-primary-light hover:border-secondary-light mb-2 overflow-visible rounded border':
                  isExpanded,
              },
              {
                'border-transparent': !isExpanded,
              }
            )}
          >
            <table className={classnames('w-full p-4')}>
              <tbody>
                <tr
                  className={classnames(
                    isDarkMode
                      ? 'hover:bg-customLightColor-level3 cursor-pointer tableRow transition duration-300'
                      : 'hover:bg-secondary-main cursor-pointer tableRow transition duration-300',
                    {
                      'bg-white': !isExpanded && !isDarkMode,
                    },
                    { 'bg-white': isExpanded && !isDarkMode }
                  )}
                  onClick={onClickRow}
                  data-cy={clickableCY}
                  style={
                    isTeleUser && isCancelled
                      ? { border: '2px solid red', backgroundColor: '#f9e9e9' }
                      : undefined
                  }                >
                  {getRowData(row).map((cell, index) => {
                    const { content, title, gridCol, key } = cell;
                    return (
                      <td
                        key={index}
                        className={classnames(
                          'truncate px-4 py-2 text align-middle',
                          { 'border-secondary-light border-b': !isExpanded },
                          getGridWidthClass(gridCol) || '',
                          getClassAccordingToKey(key)
                        )}
                        style={{ maxWidth: 0 }}
                        title={title}
                      >
                        <div className="flex">
                          {index === 0 && (
                            <div>
                              <Icon
                                name={isExpanded ? 'chevron-down' : 'chevron-right'}
                                className="mr-4 inline-flex"
                              />
                              <span className="p-2 w-1/12 text-center initialCircle rounded-full bg-primary-light text-white mr-1 " style={{ width: '8.333333%' }}>
                                {getInitials(content)}
                              </span>
                            </div>
                          )}
                          <div className={classnames({ 'overflow-hidden': true }, { truncate: true })} style={{ marginLeft: '6px' }}>
                            {content}
                          </div>
                        </div>
                      </td>
                    );
                  })}
                  <td
                    className={classnames('flex justify-end items-center py-2', {
                      'border-secondary-light border-b': !isExpanded,
                    })}
                    style={{minHeight:'4.5rem'}}
                  >
                    <div className="inline-flex items-center space-x-2 mr-3">
                      {isAiEligible && (
                        <Tooltip content={aiTooltip} className={`inline-block ${isDarkMode ? `text-white` : `text-black`}`}>
                          <Icon
                            className={`h-[20px] w-[20px]
                              ${aiIconName === 'successIcon' ? `${isDarkMode ? `text-green-400` : `text-green-800`}` : aiIconName === 'pendingIcon' ? `${isDarkMode ? `text-yellow-400` : `text-yellow-800`}` : `${isDarkMode ? `text-red-400` : `text-red-800`}`}
                            `}
                            name={aiIconName}
                          />
                        </Tooltip>
                      )}
                      {IsDuplicateStudy(tableData.clickableCY) && (
                        <Tooltip content="Duplicate" className="inline-block">
                          <div className="h-4 w-4">
                            <img src={copyIcon} className="object-contain h-[100%] w-[100%]" />
                          </div>
                        </Tooltip>
                      )}

                    {role !== _roleType.superAdmin && <button className="text-lg p-0 m-0 mr-2" onClick={btnSendClickHandler}>
                      +
                    </button>}

                    <input className="p-0 m-0 mr-12" type="checkbox" onClick={handleStudySelect} checked={isStudySelected()} />

                      {!(isTeleUser && isCancelled) && role !== 'technicianradiology' && <div className='absolute right-8 text-[#5b5baa] border-2 border-[#5b5baa] rounded-2xl p-0 font-bold' style={{ marginRight: "3rem" }}>
                        <button className='cursor-pointer p-2 text-[13px]' onClick={handleMoreClick}>
                        More
                        </button>

                      {showMenu && (
                        <div
                          id='ellipse-menu'
                          ref={divRef}
                          className="absolute bg-white rounded-md shadow-lg py-1 z-10"
                          onClick={(e) => e.stopPropagation()}
                          style={{
                            minWidth: '200px',
                            boxShadow: '2px 2px 10px rgba(0, 0, 0, 0.19)',
                            right:'0'
                          }}
                        >
                          {/* Teleradiology Actions */}
                          {role === 'hospitalsuperadmin' && isTeleradiology === 'true' && (
                            <>
                              {checkAssignedToSuperadmin(rawStudyDetails) && isCancelled ? (
                                <MenuItem
                                  text="Send to Teleradiologist"
                                  onClick={() => setConfirmationModal({
                                    title: "Send to Teleradiologist",
                                    message: "Are you sure want to send this study to Teleradiologist?",
                                    type: "sendTeleradiologist",
                                    isOpen: true,
                                    onConfirm: () => handleCheckHospitalCredit()
                                  })}
                                />
                              ) : !checkAssignedToSuperadmin(rawStudyDetails) && !isCancelled ? (
                                <MenuItem
                                  text="Send to Teleradiologist"
                                  onClick={() => setConfirmationModal({
                                    title: "Send to Teleradiologist",
                                    message: "Are you sure want to send this study to Teleradiologist?",
                                    type: "sendTeleradiologist",
                                    isOpen: true,
                                    onConfirm: () => handleCheckHospitalCredit()
                                  })}
                                />
                              ) : (
                                <>
                                  <MenuItem
                                    text="Assigned to Teleradiologist"
                                    disabled
                                  />
                                  <MenuItem
                                    text="Cancel"
                                    onClick={() => setConfirmationModal({
                                      title: "Cancel Send",
                                      message: "Are you sure want to cancel this study from Teleradiologist?",
                                      type: "cancelSend",
                                      isOpen: true,
                                      onConfirm: (e) => handleCreditAndCancelSentStudy(e)
                                    })}
                                  />
                                </>
                              )}
                              <Divider />
                            </>
                          )}

                          {/* Teleradiology Accept/Reject */}
                          {hospitalName === 'superadmin-teleradiology' && !reviewstatusFlag &&
                          role !== 'Superadmin' && role !== _roleType.radiologistAdmin &&
                          !isRejected && !isCancelled && !isAccepted && showActionBtn() && (
                            <>
                              <MenuItem
                                text="Reject"
                                onClick={() => setRejectionPopup(true)}
                              />
                              <MenuItem
                                text="Accept"
                                onClick={() => setConfirmationModal({
                                  title: "Accept Scan",
                                  message: "Are you sure want to Accept this Scan for generating report?",
                                  type: "acceptScan",
                                  isOpen: true,
                                  onConfirm: () => {
                                    setIsLoading(true)
                                    handleChangeReviewStatus(_studyReviewStatus.ACCEPTED)
                                  }
                                })}
                              />
                              <Divider />
                            </>
                          )}

                          {/* Radiologist Assignment */}
                          {(role === 'teraradiologysuperadmin' || role === 'Superadmin' || role === _roleType.radiologistAdmin) && !isCancelled && (
                            <>
                              {assignedDoctor && !isPending && !isRejected ? (
                                <>
                                  <MenuItem
                                    text={`Assigned to ${formatName(assignedDoctor?.name)}`}
                                  />
                                  {role !== _roleType.superAdmin && role !== _roleType.radiologistAdmin && (
                                    <MenuItem
                                      text="Unassign"
                                      onClick={(e) => handleUnassignDoctor(e)}
                                    />
                                  )}
                                </>
                              ) : !isAccepted && isReviewPresent && isPending && !isRejected ? (
                                <MenuItem
                                  text="Pending"
                                  disabled
                                />
                              ) : (
                                <MenuItem
                                  text="Assign Radiologist"
                                  onClick={(e) => handleRadiologist(e, row)}
                                />
                              )}
                              <Divider />
                            </>
                          )}

                          {/* Report Sending */}
                          {(role === _roleType.superAdmin || role === _roleType.radiologistAdmin) && !isCancelled && (
                            <>
                              <MenuItem
                                text="Send Report"
                                onClick={() => setConfirmationModal({
                                  title: "Send Report",
                                  message: "Are you sure want to send this Report?",
                                  type: "SendReport",
                                  isOpen: true,
                                  onConfirm: handleVerifyReport
                                })}
                              />
                              <Divider />
                            </>
                          )}
                        </div>
                      )}
                      </div>}
                  </div>
                  </td>
                </tr>
                {isExpanded && checkAcceptedStudies() && !checkCancellStudies() && (
                  <tr className="max-h-0 w-full select-text overflow-hidden bg-black">
                    <td colSpan={row.length}>{expandedContent}</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </td>
      </tr>
      <SendFilesModal
        closeButton={true}
        isOpen={isSendModalExpanded}
        title={'Series'}
        onClose={() => setIsSendModalExpanded(false)}
        shouldCloseOnOverlayClick={true}
        containerDimensions='60rem , auto'
        studyInstanceUID={clickableCY}
      />
      <AssignRadiologistModal
        isOpen={isModalRadiologist}
        onClose={() => setIsModalRadiologist(false)}
        message={''}
        isError={false}
        patientName={patientName}
        extractedValues={extractedValues}
        id={studyInstanceUid}
        onAssignSuccess={handleAssignSuccess}
        modality={modality}
        tableData={tableData}
      />
      <SuccessModal
        isSuccessModalOpen={isSuccessModalOpen}
        title={SuccessMessage}
        handleCloseModal={() => setIsSuccessModal(false)}
      />
      <Loader
        isLoaderOpen={isLoading}
      />
      <ConfirmationPopup
        isOpen={confirmationModal?.isOpen}
        title={confirmationModal?.title || "Title"}
        message={confirmationModal?.message || ""}
        onConfirm={confirmationModal?.onConfirm}
        onCancel={() =>
          setConfirmationModal((prev) => ({ ...prev, isOpen: false }))
        }
      />
      <RejectionModal
       isOpen={rejectionPopup}
       title="Rejection Reason"
       onConfirm={()=>{

         handleChangeReviewStatus(_studyReviewStatus.REJECTED)
       }}
       onCancel={() => {setRejectionPopup(false)
         setRejectionReasonText('')}}
       textField={
        <>
          <textarea
             value={rejectionReasonText}
             onChange={(e) => setRejectionReasonText(e.target.value)}
             placeholder="Write your reason here..."
             className="textfield w-full p-2 border rounded text-font"
             minLength={4}
          />
          {rejectionReasonText.length > 0 && rejectionReasonText.length < 6 && (
             <p className="text-red-500 text-sm">Minimum 6 characters required</p>
          )}
        </>
       }
      />
      {OpenErrorModal && (
        <Notification
          id="unassign study"
          message={"Cannot unassign the study as report has been generated!"}
          type="info"
          actions={[
            {
              type: 'cancel',
              text: 'ok',
              value: -1,
            }
          ]}
          onSubmit={() => setOpenErrorModal(false)}
        />
      )}
    </>
  );
};

StudyListTableRow.propTypes = {
  tableData: PropTypes.shape({
    row: PropTypes.array,
    expandedContent: PropTypes.element,
    onClickRow: PropTypes.func,
    isExpanded: PropTypes.bool,
    dataCY: PropTypes.string,
    clickableCY: PropTypes.string,
    rawStudyDetails: PropTypes.object,
  }),
  extractedValues: PropTypes.object,
  setStudiesToSend: PropTypes.func,
  clearFilters: PropTypes.func,
  isCancelled: PropTypes.bool,
  isAccepted: PropTypes.bool,
  reviewstatusFlag: PropTypes.string,
  cancellationReason: PropTypes.string,
  acceptedradiologistId: PropTypes.string,
  rejected_radiologist_ID: PropTypes.array,
  acceptance_time: PropTypes.string,
  isAutoRejected: PropTypes.bool,
  assigned_time: PropTypes.string,
  isReviewPresent: PropTypes.bool,
  assigned_radiologist: PropTypes.string,
};

export default StudyListTableRow;
